import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import {
  Box,
  Spinner
} from '@chakra-ui/react';

const ProtectedRoute = ({ element }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <Spinner size="xl" />
      </Box>
    );
  }

  return user ? element : <Navigate to="/auth" />;
};

export default ProtectedRoute;